import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { getPayersList } from '../../../../redux/slices/VisitsSlice'
import CustomButton from '../../../../shared/CustomButton'
import DropdownField from '../../../../shared/DropdownField'
import DatePicker from '../../../../shared/DatePicker'
import { practionerDepartmentOptions } from '../../../../constants/UserConstants'
import { fetchData } from '../../../../helpers/fetchData'
import MultiSelectField from '../../../../shared/MultiSelectField'
import { payersOptionsFormat } from '../../../../constants/BeneficiaryConstants'
import TextInput from '../../../../shared/TextInput'
import { validateOneMonthRange, getOneMonthMaxDate, getMinDate } from '../../../../utils/dateRangeValidation'

function PayerReportFilters({
  payloadData,
  setPayloadData,
  requestReport,
  hidePolicies = false,
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [departments, setDepartments] = useState([]);
  const [policies, setPolicies] = useState([])
  const { payersData, isLoading: isLoadingPayers } = useSelector(
    (state) => state?.visits
  );

  const handleChange = event => {
    const { name, value } = event.target || {}
    if (name == 'payer_id' && value) {
      fetchPayerPolicies(value)
      setPayloadData(prevValues => ({
        ...prevValues,
        [name]: value,
        policy_numbers: [],
      }))
    } else {
      setPayloadData(prevValues => ({
        ...prevValues,
        [name]: value,
      }))
    }
  }

  const handleApply = async () => {
    if (!validateOneMonthRange(payloadData?.start_date, payloadData?.end_date, t)) return
    await requestReport(payloadData)
  }

  const handleReset = async () => {
    const payload = {
      end_date: moment().toDate(),
      start_date: moment().subtract(1, 'day').toDate(),
      payer_id: '',
      department_id: '',
      policy_numbers: [],
      invoice_number: '',
      file_number: '',
    }
    setPayloadData(payload)
    await requestReport(payload, payload?.filters?.status)
  }

  const fetchDepartments = async () => {
    const response = await fetchData('POST', '/v3/department/getList', {});
    response?.data ? setDepartments(practionerDepartmentOptions(response.data)) : setDepartments([])
  };

  const fetchPayerPolicies = async (payerId) => {
    const response = await fetchData('POST', '/v3/insurancePolicy/getByPayerId', { payer_id: payerId });
    response?.data ? setPolicies(response.data) : setPolicies([])
  }

  useEffect(() => {
    fetchDepartments()
    dispatch(getPayersList())
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex  items-center gap-2">
        <DatePicker
          name="start_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.start_date}
          onChange={handleChange}
          placeholder={t('Selectstartdate')}
          format="YYYY-MM-DD"
        />
        <DatePicker
          name="end_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.end_date}
          onChange={handleChange}
          placeholder={t('Selectenddate')}
          format="YYYY-MM-DD"
          minDate={getMinDate(payloadData?.start_date)}
          maxDate={getOneMonthMaxDate(payloadData?.start_date)}
        />
        <DropdownField
          filter
          useFormik={false}
          options={departments}
          value={payloadData?.department_id}
          handleChange={(e) => {
            const selectedValues = e.value || [];
            setPayloadData({
              ...payloadData,
              department_id: selectedValues
            });
          }}
          optionLabel='label'
          optionValue='value'
          placeholder={t('Select Department')}
          display='chip'
        />
        <DropdownField
         // parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
          placeholder={`${t('Select payer')}`}
          name="payer_id"
          filter
          useFormik={false}
          options={payersOptionsFormat(payersData?.data)}
          value={payloadData?.payer_id}
          handleChange={handleChange}
        />

        {!hidePolicies && (
          <MultiSelectField
            disabled={!payloadData?.payer_id}
            filter
            useFormik={false}
            options={policies.map(item => ({
              label: `${item?.policy_holder_name} (${item?.policy_number})`,
              value: item?.policy_number,
            }))}
            value={payloadData?.policy_numbers}
            handleChange={(e) => {
              const selectedValues = e.value || [];
              setPayloadData({
                ...payloadData,
                policy_numbers: selectedValues
              });
            }}
            optionLabel='label'
            optionValue='value'
            placeholder={t('Select Payer Policies')}
            display='chip'
            selectedItemsLabel='{0} policies selected'
          />
        )}

        <TextInput
          name="invoice_number"
          value={payloadData?.invoice_number || ''}
          handleChange={handleChange}
          placeholder={t('Invoice Number')}
          useFormik={false}
          parentClass="!mb-0"
        />

        <TextInput
          name="file_number"
          value={payloadData?.file_number || ''}
          handleChange={handleChange}
          placeholder={t('MRN')}
          useFormik={false}
          parentClass="!mb-0"
        />
      </div>

      <div className="flex items-center gap-2 ml-auto">
        <CustomButton
          //label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType="primary"
          icon="pi pi-filter"
          className="w-fit h-[35px]"
          onClick={handleApply}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType="reset"
          icon="pi pi-sync"
          className="w-fit h-[35px]"
          onClick={handleReset}
        />
      </div>
    </div>
  )
}

export default PayerReportFilters
